import "assets/styles/reports/balanceSheet.scss";
import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material";
import { useAppDispatch, useAppSelector } from "store/store";
import ReactToPrint from "react-to-print";
import BasicButton from "../../BasicInputs/BasicButton";
import { apiGetAccounting } from "../../../api/accountingApi";
import usePrintInstallment from "./usePrintInstallment";
import { apiGetInstallment } from "api/installmentApi";

const ItemContainer = styled("div")(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    marginBottom: "36px",
}));

export default function PrintInstallMent({
    installmentId,
    index,
    installmentType,
    autoPrint,
}: {
    installmentId: string | number;
    installmentType: string;
    autoPrint?: boolean;
    index: number
}) {
    const dispatch = useAppDispatch();
    const store = useAppSelector((state: any) => state);
    const business = store.businessReducer?.business;
    const { token } = business;

    const [installment, setInstallment] = useState(null);
    const [installmentIsFetched, setinstallmentIsFetched] = useState(false);

    const callBack = (installment: any) => {
        setInstallment(installment)
        return setinstallmentIsFetched(true);
    };

    const printRef = useRef<any>(null);
    const { content, contentRef } = usePrintInstallment({ installments: installment, index });
    useEffect(() => {
        dispatch(apiGetInstallment(installmentId, token, (res: any) => {
            callBack(res)
        }));
    }, [token]);

    useEffect(() => {
        if (installmentIsFetched && autoPrint) {
            printRef.current.handleClick()
           // setinstallmentIsFetched(false)
        };
    }, [installmentIsFetched]);

    return (
        <ItemContainer style={{ height: "fit-content", backgroundColor: "white" }}>
            <div className="hidden">{content}</div>
            <ReactToPrint
                ref={printRef}
                trigger={() => (
                    <BasicButton fullWidth variant="outlined" className="hidden">
                        <span>چاپ روکش سند حسابداری</span>
                    </BasicButton>
                )}
                content={() => contentRef.current}
            />
        </ItemContainer>
    );
}
